import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--customers--item"
export default class extends Controller {
  static values = {
    linkTo: String,
    turboFrame: String,
    turboAction: String
  }

  connect() {
  }

  link() {
    if (!this.hasLinkToValue) { return }

    const link = this.linkToValue
    const turboFrame = this.turboFrameValue
    const turboAction = this.turboActionValue

    Turbo.visit(link, { frame: turboFrame, action: turboAction })
  }
}
